module.exports = __webpack_public_path__ + "static/img/discount-invite.80c309a9.png";